module.exports = __webpack_public_path__ + "static/media/product-item.23567738.jpeg";